module.exports = __webpack_public_path__ + "img/lp-electronic-cigarette.b1e70826.svg";